import * as Yup from 'yup'
import { Form, Col, Row } from 'react-bootstrap'
import { Options } from '../SelectOptions';
import { CustomFormSelect, CustomFormControl } from '../../../../StyledComponents';
import { parse } from 'date-fns/parse'
import { isDate } from 'date-fns/fp'

function parseDateString(value, originalValue) {
    const parsedDate = isDate(originalValue) || originalValue==null
        ? originalValue
        : parse(originalValue, "yyyy-MM-dd", new Date());

    return parsedDate;
}
const today = new Date();

export const Schema = Yup.object().shape({
    salutation: Yup.string().required("Angabe ist erforderlich"),
    dateOfBirth: Yup.date()
        .nullable()
        .min(new Date(1900, 1, 1), "Geburtsdatum muss größer als 01.01.1900 sein.")
        .typeError("Bitte geben Sie einen gültigen Wert an")
        .transform(parseDateString).max(today, "Geburtsdatum kann nicht in der Zukunft liegen")
    ,
});

export const SalutationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors } = props;
    return (
        <>
            <Row className="mb-3">
                <Form.Group as={Col} controlId="formSalutation">
                    <Form.Label>Anrede*</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="salutation"
                        value={values.salutation}
                        isValid={touched.salutation && !errors.salutation}
                        isInvalid={touched.salutation && errors.salutation}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">Bitte auswählen...</option>
                        {Options.Salutation.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.salutation}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} controlId="formDateOfBirth">
                    <Form.Label>Geburtsdatum</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Geburtsdatum eingeben"
                        type="date"
                        name="dateOfBirth"
                        value={values.dateOfBirth}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.dateOfBirth && !errors.dateOfBirth}
                        isInvalid={touched.dateOfBirth && errors.dateOfBirth}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.dateOfBirth}
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
        </>
    );
};